import { giphyBlack, giphyDarkestGrey } from '@giphy/js-brand'
import styled, { css, keyframes } from 'styled-components'
import ControlSize, { controlBorderRadius, controlHeight } from '../../../types/control-size'
import { brightnessFromColor } from '../../../utils/color/brightness'
import IconButton from '../icon-button'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

export const Button = styled(IconButton)<{ isOpen: boolean }>`
    flex-shrink: 0;
    height: auto;

    svg {
        transform: rotate(${({ isOpen }) => (isOpen ? 180 : 0)}deg);
        transition: transform 0.15s ease-out;
    }
`

export const Content = styled.div`
    animation: ${fadeIn} 0.15s ease-out;
    padding: 0.75em 1em;
`

export const Header = styled.div<{ controlColor: string }>`
    align-items: stretch;
    border-radius: inherit;
    display: flex;
    position: relative;
    user-select: none;

    &:not(:only-child) {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    ${({ controlColor }) => {
        const color = brightnessFromColor(controlColor) > 0.5 ? giphyBlack : '#fff'

        return css`
            background: ${controlColor};
            color: ${color};
        `
    }}
`

export const Label = styled.div`
    margin: auto 0;
    width: 100%;
`

export const LabelText = styled.div`
    align-self: center;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 1em;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`

export const Container = styled.div<{ controlSize: ControlSize }>`
    background: ${giphyDarkestGrey};
    border-radius: ${({ controlSize }) => controlBorderRadius(controlSize)}px;
    width: 100%;

    ${Header} {
        min-height: ${({ controlSize }) => controlHeight(controlSize)}px;
    }
`
